import { Component, inject, OnInit, signal } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { Router } from '@angular/router';
import { FollowedAuthor } from '../../models/followed-author';
import { ToastService } from 'src/app/_core/services/toast.service';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'app-authors',
  templateUrl: './authors.component.html',
  styleUrls: ['./authors.component.scss'],
})
export class AuthorsComponent implements OnInit {
  selectedAuthor: FollowedAuthor | null = null;

  private readonly toastService = inject(ToastService);
  private readonly apiService = inject(ApiService);

  readonly showUnfollowedAuthorsDialog = signal<boolean>(false);

  constructor(public userService: UserService, private router: Router) { }

  ngOnInit() {
    this.userService.loadFollowedAuthors().subscribe();
  }

  addAuthors() {
    this.router.navigate(['/search', 'authors']);
  }

  goToAuthor(author: FollowedAuthor) {
    const queryParams = {
      limit: 24,
      offset: 0,
      facets: `autor_facet_ss:"${author.author}"`,
      order: 'fechaModifica_dt:desc',
    };

    this.router.navigate(['/results'], { queryParams: queryParams });
  }

  selectAuthor(event: Event, author: FollowedAuthor) {
    event.stopPropagation();
    this.selectedAuthor = author;
  }

  unfollowAuthor() {
    if (this.selectedAuthor) {
      this.userService.unfollowAuthor(this.selectedAuthor.author).subscribe();
    }
  }

  unfollowAll() {
    this.showUnfollowedAuthorsDialog.set(false);
    this.apiService.unfollowAllAuthors(this.userService.getUserId()).subscribe(() => {
      this.userService.followedAuthors = [];
      this.toastService.showToast('lists.allAuthorsUnfollowed');
    });

  }
}
